import { SPLITS, useFeatureFlag } from '@/helpers/useFeatureFlag'
import { Star } from '@mui/icons-material'
import { Stack, Tooltip, Typography } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  rating: number
  totalRatings?: number | null
}

const SupplierRating: React.FC<Props> = ({ rating, totalRatings }) => {
  const { t } = useTranslation()
  const gmRatingDisplayEnabled = useFeatureFlag(SPLITS.GM_ORDER_RATING_DISPLAY)
  const ratingLabel = Math.round((rating + Number.EPSILON) * 100) / 100 // 2 decimal places max
  const content = (
    <Stack
      flexWrap="nowrap"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      // spacing={0.5}
      direction="row">
      <Star sx={{ fontSize: 16 }} htmlColor="white" />
      <Stack
        flexWrap="nowrap"
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        spacing={0.5}
        direction="row">
        <Typography noWrap fontSize={12} fontWeight={600} color="common.white">
          {ratingLabel}
        </Typography>
        {(totalRatings || 0) > 0 && (
          <Tooltip title={`${totalRatings} rating${(totalRatings || 0) > 1 ? 's' : ''}`}>
            <Typography fontSize={9} fontWeight={600} color="common.white">
              ({totalRatings})
            </Typography>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  )

  if (!gmRatingDisplayEnabled) return content

  return <Tooltip title={t('marketplace:ratingTooltip')}>{content}</Tooltip>
}

export default SupplierRating
export { SupplierRating }
